// client/src/coms/workspace/engagement.js
// "The user is writing in this conversation": typed a non-empty draft (not a draft restored when the conversation
// opened) or sent something. The conversation tabs (ComsLayout) turn its preview tab into a saved tab.
// Conversation ids are the tab ids (workspaceModel tabIdOf): `c:<serverKey>:text:<id>` or `d:<threadId>`.
export const ENGAGED_EVENT = 'vox-conversation-engaged';

export function markEngaged(conversationId) {
  const id = String(conversationId || '');
  if (!id) return;
  try {
    window.dispatchEvent(new CustomEvent(ENGAGED_EVENT, { detail: { id } }));
  } catch {}
}
